import './UploadcareWidget.module.less';

export { default as openUploadcareModal } from '@zola-helpers/client/dist/es/uploadcare/openUploadcareModal';
